import { DataStudioJobTypeEnum, DataStudioJobStatusEnum } from "~/graphql/supergraphEnums";
import { type DataStudioJobEnvironmentEnum } from "~/graphql/supergraphTypes";
import { EffectiveStatus } from "~/hooks/useDataStudioQueries/constants";

export const JOB_TYPE_OPTIONS = [
  { value: DataStudioJobTypeEnum.ArenaCreation, label: "Arena Creation" },
  { value: DataStudioJobTypeEnum.ArenaLock, label: "Arena Lock" },
  { value: DataStudioJobTypeEnum.ArenaUnlock, label: "Arena Unlock" },
  { value: DataStudioJobTypeEnum.CrmImport, label: "CRM Import" },
  { value: DataStudioJobTypeEnum.OpcoImport, label: "OpCo Import" },
];

export const ENVIRONMENT_OPTIONS: Array<{
  value: DataStudioJobEnvironmentEnum;
  label: string;
}> = [
  { value: "TEST", label: "Test" },
  { value: "PRODUCTION", label: "Production" },
];

export const ACTIVE_STATUSES = [EffectiveStatus.IN_PROGRESS];

export const COMPLETED_STATUSES = [EffectiveStatus.COMPLETED];

export const FAILED_STATUSES = [EffectiveStatus.FAILED];

export const BACKEND_ACTIVE_STATUSES: string[] = [
  DataStudioJobStatusEnum.InProgress,
  DataStudioJobStatusEnum.Created,
];

export const BACKEND_COMPLETED_STATUSES: string[] = [DataStudioJobStatusEnum.Completed];

export const BACKEND_FAILED_STATUSES: string[] = [DataStudioJobStatusEnum.Failed];
